import { useNavigate } from 'react-router-dom'
import { Table, Input } from 'reactstrap'
import { enterKeyHandler } from '../../../utils'
import useForm from '../../CustomHooks/FormHook'
import '../Custom.css'
import { initialFormValues, submitFormValues } from '../CustomUtils'
import DateRangeInput from '../DateRangeInput'
import FormHeading from '../FormHeading'
import FormSubmitButton from '../FormSubmitButton'

export default function CalendarActivityReportForm({ location }) {
  console.log('CalendarActivityReportForm rendered: ', location)

  let init = {
    actionDateFrom: '',
    actionDateTo: '',
    actionType: '',
  }
 
  const navigate = useNavigate()
  init = initialFormValues('CalendarActivityReportForm', navigate, init)
  const { inputs, handleInputChange, handleSubmit } = useForm(init, submitSearch, enterKeyHandler(submitSearch))

  async function submitSearch() {
    submitFormValues('CalendarActivityReportForm', navigate, inputs, 'activity.calendar')
  }

  return (
    <div className="custom-scroll">
      <form className="form" onSubmit={handleSubmit} style={{ maxWidth: '700px', margin: '20px auto' }}>
        <div>
          <Table bordered className="custom-table custom-form-table" style={{backgroundColor: 'white'}}>
            <FormHeading headingText='Calendar Activity Report' />
            <tbody>
              <DateRangeInput label='Action Date' name='actionDate' handleInputChange={handleInputChange} defaultValueTo={inputs.actionDateTo} defaultValueFrom={inputs.actionDateFrom} />
              <tr>
                <td><b>Action</b></td>
                <td> 
                  <Input type="select" name="actionType" onChange={handleInputChange} defaultValue={inputs.actionType} style={{width: 'auto', display: 'inline-block', marginRight: '5px'}}>
                    <option value={''}>ALL</option>
                    <option value={'2721'}>Modify</option>
                    <option value={'2720'}>Submit</option>
                  </Input>
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
        <FormSubmitButton />
      </form>
    </div>
  )
}
